export const hoverMixin = (content: string): string => {
  return `&:active {
      ${content}
    }
    @media (hover: hover) {
      &:hover {
        ${content}
      }
    }`;
};



// WEBPACK FOOTER //
// ./src/utils/style.ts